/**
 * Temporary: hide in-app chess in Break Room Cup frontends.
 * Chess gameplay lives on https://chessarenas.com (Break Room Cup product).
 *
 * KEEP: landing ChessArenas.com banner, /arena demo page + nav "Chess Arena".
 * Set to false (or remove gates) to restore in-app chess create/play.
 */
export const HIDE_IN_APP_CHESS = true

export const CHESSARENAS_URL = 'https://chessarenas.com'
